<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-iframe-resize="{ log: true }"
    ></iframe>
  </div>
</template>

<script>
import { dashboardUrl } from "@/helpers/dashboards";
export default {
  data() {
    return {
      url:
        dashboardUrl("retards")
    };
  },
  created() {
  },
};
</script>
